/*
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-default'

export const subHiddenBreakpoint = 1440
export const menuHiddenBreakpoint = 768
export const defaultLocale = 'br'
export const localeOptions = [
  { id: 'br', name: 'Português', direction: 'ltr' },
  { id: 'en', name: 'English', direction: 'ltr' },
  { id: 'es', name: 'Español', direction: 'ltr' }
]

export const searchPath = '/app/pages/search'
export const servicePath = 'https://api.coloredstrategies.com'

/*
Color Options:
"light.purple", "light.blue", "light.green", "light.orange", "light.red", "dark.purple", "dark.blue", "dark.green", "dark.orange", "dark.red"
*/
export const themeColorStorageKey = '__theme_color'
export const defaultColor = 'light.blue'
export const isDarkSwitchActive = false
export const defaultDirection = 'ltr'
